<template>
	<div style="background-color:#fffcf7;" class="container">
		<!-- {{ flds }} -->
		<div class="w-100 overflow-hidden p-3 h-center">
			<div
				class="col-lg-10 col-md-10 col-sm-12 col-xs-12 p-3 border-15 shadow bg-white text-center"
				data-aos="flip-up"
				data-aos-easing="ease-out-cubic"
				data-aos-duration="2000"
				style="
				display: flex;
				align-items: center;
				justify-content: center;
				align-content: center;
				"
			>
				<div style="width: 75%; max-width: 500px;">
					<h2 class="text-center bMikhak">
						ثبت نام استاد
					</h2>
					<textInput
						autofocus="true"
						@inputTxtFunc="(e)=>{ val.rand = e; }"
						:val="val.rand"
						label="کد اعتبار سنجی"
					/>
					<p class="mt-3">
					ثبت نام شما به منزله پذیرش
					<router-link 
							to="/rules"  
							class="text-success under-line"
							style="font-size: 1rem; text-decoration-color: #397972;"
							>
							قوانین و مقررات
						</router-link>
					می باشد.
				</p>
					<btn @clickMe="getPhone()" class="w-100 mt-3" textClass="w-100" text="ورود" />
					<p class="h-center p-3 text-center">
						مهلت باقی مانده:
						<span class="bold text-success yekan" v-if="time>0">
							&nbsp;
							&nbsp;
							{{ minutes2time(time) }}
						</span>
						<span class="text-success yekan" v-else>
							<btn
								type=""
								textClass="text-success"
								@clickMe="checkPhone()"
								text="ارسال دوباره"
							/>
						</span>
					</p>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import textInput from  "../../UI/input/textInput.vue";
	import btn from  "../../UI/button/btn.vue";
	import { error } from  "../../assets/library/messege.js";
	import { minutes2time } from  "../../assets/library/convertTime.js";

	export default {
			name: 'check_phone_teacher',
		data(){
			return {
				error: error,
				minutes2time: minutes2time,
				baseurl: window.baseurl,
				flds: [],
				rand: '',
				time: '120',
				val:{
					"rand": "",
					"phone": "",
				},

			}
		},
		components: {
			btn,
			textInput,
		},
		props: {
			value: {
				default: {
					page: 1,
				},
			},
		},
		mounted(){
			this.val.phone = this.value.mobile;
			this.$swal.close();
			this.checkPhone(this.val.phone);

		},
		methods:{
			checkPhone(mobile = this.val.phone, THIS = this){
				this.time= '120';
				window.$.post(window.baseurl + 'accountTeacher/oneTimePassword', 
				{ token: this.$localStorage.get("user"), mobile: mobile }, 
				function(D){
					if(D.ok==true){
						THIS.flds = D.data;
						THIS.sendSmsF(mobile);
					}else{
						THIS.$swal.fire({
							position: 'center',
							type: 'error',
							title: 'شماره تلفن همراه وارد شده قبلا در سیستم ثبت نشده است',
							timer: '2000',
							showConfirmButton: false
						});
					}
				}, "json");
				this.timer();
			},
			// ***********************************************************************
			sendSmsF(phone){
				var txt = this.flds.text;
				window.$.post(window.sendSms, {token: this.$localStorage.get("user"), phn: phone, txt: txt }, function(){
				}, "json");
			},
			// *********************************************************************
			showRule(THIS = this){
				var index_text = this.indexFinder(this.$localStorage.get('settings'), "3");
				THIS.$swal.fire({
					position: 'center',
					type: '',
					html: "<p class='text-justify'>" + this.$localStorage.get('settings')[index_text].dsc + "</p>" ,
					width: '80%',
					title: this.$localStorage.get('settings')[index_text].title,
					showCloseButton: true,
					showConfirmButton: true,
					confirmButtonText: "بستن",
				});
			},
			// ***********************************************************************
			getPhone(){
				// alert(123);
				if(this.flds.data==this.val.rand){
					this.sav_teacher();
				}else{
					this.$swal.fire({
						position: 'center',
						type: 'error',
						title: 'رمز یکبار مصرف وارد شده اشتباه است',
						timer: '2000',
						showConfirmButton: false
					});
				}
			},
			// ***********************************************************************
			sav_teacher(THIS = this){
				window.$.post(window.baseurl + 'accountTeacher/create', 
				{ token: this.$localStorage.get("user"), phone: this.val.phone }, 
				function(D){
					THIS.$localStorage.set('s_id_t', D.data);
					THIS.value.id = D.data;
					THIS.loader(THIS.value.id);
				}, "json");
			},
			
//********************************************** */
loader(id, THIS = this) {
	this.val.id = id;
	window.$.get(window.baseurl + 'accountTeacher/' + id, {}, function (D) {
		THIS.value = D.data.username;
		THIS.val.value = D.data.username;
		// THIS.$localStorage.set('user', D.data);	
		THIS.val.value = THIS.value;
		
		if(THIS.val.value.status=="10"){
			//نیاز به بررسی
			THIS.val.page = 8;
			THIS.$emit('next_page', THIS.val);
		} 
		else if(THIS.val.value.status=="2"){
			THIS.$router.push('/reserved/user/list');
		} 
		else if(THIS.val.value.status=="1"){
			// تایید شده ها
			THIS.val.page = 9;
			THIS.$emit('next_page', THIS.val);
		}
		else if(THIS.val.value.status=="7"){
			// رها شده
			// THIS.$localStorage.set("s_id_t", id);
			THIS.val.page = 4;
			THIS.$emit('next_page', THIS.val);
		}
		else if(THIS.val.value.status=="11"){
			// نقص مدارک
			THIS.val.page = 10;
			THIS.$emit('next_page', THIS.val);
		}
		else if(THIS.val.value.status=="13"){
			//نیاز به بررسی
			THIS.val.page = 8;
			THIS.$emit('next_page', THIS.val);
		}	
		else if(THIS.val.value.status=="12"){
			// رد شده توسط داور
			THIS.val.page = 11;
			THIS.$emit('next_page', THIS.val);
		} else {
			// THIS.$localStorage.set("s_id_t", id);
			THIS.value.page = 2;
			THIS.emit(THIS.value); 
		}
	}, "json");
},
			// ***********************************************************************
			emit(val){
				this.$emit('next_page', val);
			},
			// ***********************************************************************
			timer(THIS = this){
				if(THIS.time > 0) {
					setTimeout(() => {
							THIS.time -= 1
						THIS.timer();
					}, 1000)
				}
			},
		}
	}
</script>
<style>

</style>
